export default __webpack_public_path__ + "static/media/dabckj.7cd4110a.jpg";